export enum Change {
  INCREASE = "INCREASE",
  DECREASE = "DECREASE"
}
